<template>
  <div>
    <p>{{ t('convertElementalPPMtoNPK') }}</p>
    <EquationBlock :equations="equations" />
    <hr />
    <div class="row">
      <div class="col-sm">
        <!-- Inputs -->
        <FixedUnitInput
          :input-label="t('fertilizerPPMN')"
          v-model.number="nPPM"
          :unit="t('ppm')"
        />
        <FixedUnitInput
          :input-label="t('fertilizerPPMP')"
          v-model.number="pPPM"
          :unit="t('ppm')"
        />
        <FixedUnitInput
          :input-label="t('fertilizerPPMK')"
          v-model.number="kPPM"
          :unit="t('ppm')"
        />
        <!-- Additional inputs for Mass Fraction -->
        <p>{{ t('massPercentageCompositionNote') }}</p>
        <FixedUnitInput
          :input-label="t('nMassFraction')"
          v-model.number="nMP"
        />
        <FixedUnitInput
          :input-label="t('pMassFraction')"
          v-model.number="pMP"
        />
        <FixedUnitInput
          :input-label="t('kMassFraction')"
          v-model.number="kMP"
        />
      </div>
      <div class="col-sm">
        <!-- Outputs -->
        <FixedUnitOutput
          :output-label="t('nitrogenPercentage')"
          :number="nPercentage"
          :unit="t('percent')"
        />
        <FixedUnitOutput
          :output-label="t('phosphorusPercentage')"
          :number="pPercentage"
          :unit="t('percent')"
        />
        <FixedUnitOutput
          :output-label="t('potassiumPercentage')"
          :number="kPercentage"
          :unit="t('percent')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import { defaultRound } from '../../utils/math';
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput,
      EquationBlock,
    },
    setup() {
      const nPPM = ref(250000);
      const nMP = ref(1);
      const pPPM = ref(17500);
      const pMP = ref(0.43641);
      const kPPM = ref(16600);
      const kMP = ref(0.83014);

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('tdsToNpkEquations');
      });
  
      const calculatePercentage = (ppm, massPercent) => {
        const naivePercentage = ppm.value / 10000; // 1 - 100
        return naivePercentage / massPercent.value;
      };
  
      const nPercentage = computed(() => defaultRound(calculatePercentage(nPPM, nMP)));
      const pPercentage = computed(() => defaultRound(calculatePercentage(pPPM, pMP)));
      const kPercentage = computed(() => defaultRound(calculatePercentage(kPPM, kMP)));
  
      return {
        nPPM, pPPM, kPPM, nMP, pMP, kMP,
        nPercentage, pPercentage, kPercentage,
        equations,
        t: translations.t
      };
    },
  };
  </script>
  